import { AppBar as MuiAppBar, Box, Toolbar, Button, Container, Typography, useScrollTrigger } from '@mui/material'
import { Bar, fontTextSmall, fullCenter, Logo } from '../../base';
import ExitToAppRoundedIcon from '@mui/icons-material/ExitToAppRounded';
import { signOut } from 'firebase/auth';
import { auth } from '../../Firebase/firebase_init';
import { useDialog } from '../../Providers/Dialog/DialogProvider';
import LangLink from '../../Localization/LangLink';


export default function AdminBar() {
    const { setDialog } = useDialog();

    const nav = [
        { text: 'Statistics', link: '/stats' },
        { text: 'Contact', link: '/tickets_list' },
        { text: 'Blog', link: '/blog' },
    ];

    return (
        <Bar colors={{
            main: '#FFF',
            top: '#FFF'
        }}>
            <Box sx={{ ml: 'auto', ...fullCenter, flexDirection: 'row' }}>
                <Box sx={{ py: '4px', px: '4px', cursor: 'pointer', mr: '16px' }} onClick={() => {
                    signOut(auth).catch((err) => {
                        setDialog("Failed to sign out. " + err?.message);
                    });
                }}>
                    <ExitToAppRoundedIcon sx={{ color: '#4534C2', display: 'block' }} />
                </Box>
                {nav.map((n, i) => <Box key={"AdmnNavL" + i} component={LangLink} to={n.link} sx={{ ml: '8px', textDecoration: 'none', ...fullCenter }}>
                    <Typography sx={{ py: '4px', px: '8px', fontWeight: 'bold', ...fontTextSmall }}>{n.text}</Typography>
                </Box>)}
            </Box>
        </Bar>
    )
}
